export default __webpack_public_path__ + "static/media/folder-opened.89dbb548.svg";